t = require('views/internal/recup-with-helpers')('credit_card')
usTerritories = require 'data/us-territories'

module.exports = BillingFormUtil =

  localizeCountry: ([value, key]) -> [value, t.l(['countries', key])]

  requiresZipCode: (country) ->
    country == 'US' || country == 'CA' || country in usTerritories

  testZipCode: (zipCode, country) ->
    if country == 'US' || country in usTerritories
      # USA format: 5 or 9 digits
      zipCode.replace(/\D/g, '').length in [5, 9]
    else if 'CA'
      # Canadian format: A1A-1A1
      /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(zipCode)
    else
      false

  getCvvErrorKey: (cardType) ->
    if cardType == 'american-express'
      'please-enter-a-valid-4-digit-amex-cid'
    else
      'please-enter-a-valid-3-digit-cvv'

  unsupportedCardTypes: ['maestro']

  isUnsupportedCardType: (cardType) ->
    cardType in @unsupportedCardTypes

  getCardErrorFormatter: (cardType, niceCardType) ->
    if @isUnsupportedCardType(cardType)
      -> t.format 'unsupported-credit-card-type', niceCardType: niceCardType
    else
      -> t.format 'please-provide-your-full-card-number-for-credit-card-verification'

  getErrorField: (errorType) ->
    switch errorType
      when 'SHOP_INVALID_TAX_ZIP_CODE' then 'zipCode'
      when 'SHOP_INVALID_TAX_COUNTRY_CODE' then 'country'
      when 'SHOP_INVALID_TAX_ID' then 'taxId'
      when 'SHOP_UNSUPPORTED_CARD_TYPE' then 'number'



// WEBPACK FOOTER //
// ./app/scripts/views/billing/internal/billing-form-util.coffee